import React from "react";
import { arrayHasAtLeastTwoItems } from "common/utils/arrays";
import { Button } from "../../../../Common/Button";
import { Icon } from "../../../../Common/Icons/LucideIcons";
import { MenuButtonsWrapper } from "./__styles__/SubmissionsBuilder";
import { useBuilderFormContext } from "./form";
import {
  SUBMISSIONS_BUILDER_MODE,
  useSubmissionsBuilderContext,
  useSubmissionsBuilderMode,
} from "./SubmissionsBuilderContext";

const TEMP_isDisabled = true;

export function MenuButtons() {
  const { formState } = useBuilderFormContext();
  const [mode, setMode] = useSubmissionsBuilderMode();
  const { existingSubmissionType } = useSubmissionsBuilderContext();
  const hasVersionHistory = arrayHasAtLeastTwoItems(
    existingSubmissionType?.versions ?? [],
  );

  const canOpenVersionHistory =
    hasVersionHistory &&
    mode === SUBMISSIONS_BUILDER_MODE.BUILD &&
    !formState.isDirty;

  return (
    <MenuButtonsWrapper>
      {mode === SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY ?
        <Button
          styleVariant="outlineLight"
          size="small"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.BUILD)}
        >
          Return to current version
        </Button>
      : canOpenVersionHistory ?
        <Icon
          iconName="history"
          color="contentSecondary"
          size={16}
          cursor="pointer"
          testId="version-history"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY)}
        />
      : null}
      <Button styleVariant="primary" size="small" disabled={TEMP_isDisabled}>
        Save
      </Button>
    </MenuButtonsWrapper>
  );
}
